import { useEffect, useState } from 'react';
import { getTrainingOverview } from '../../training';
import { Assignment } from '../../training';
import { useUser } from '../../authentication';
import { handleError } from '../../../utils/apiUtils';
import cacheService from '../../../services/cacheService';

export type Organization = {
  _id: { id: string };
  name: string;
};

export default function useTraining(shouldGetCompleted = false) {
  const { user } = useUser();
  const userId = user?.userId || '';
  const [data, setData] = useState<{ training?: Assignment[]; isLoading?: boolean; isError?: boolean }>({
    isLoading: true,
  });

  function sortTraining(trainingResponse: Assignment[]) {
    if (shouldGetCompleted) {
      return trainingResponse.sort(
        (a, b) => ('completedOn' in b ? b.completedOn : 0) - ('completedOn' in a ? a.completedOn : 0)
      );
    } else {
      return trainingResponse.sort(
        (a, b) => ('assignedOn' in b ? b.assignedOn : 0) - ('assignedOn' in a ? a.assignedOn : 0)
      );
    }
  }

  useEffect(() => {
    cacheService.remove('redirectingThroughTabs');
    getTrainingOverview(userId, shouldGetCompleted)
      .then((trainingResponse: Assignment[]) => {
        setData({
          training: sortTraining(trainingResponse),
          isLoading: false,
        });
      })
      .catch((error: Error) => {
        handleError(error);
        setData({ isLoading: false, isError: true });
      });
  }, [userId, shouldGetCompleted]);

  return { data, setData };
}
